<div
  *ngIf="!isDisabled"
  class="flex justify-between flex-1 px-2 pb-2 space-x-6"
>
  <button
    mat-button
    type="button"
    class="h-8 text-xs font-semibold bg-project-4500/60 text-project-300"
    (click)="createNewSlide()"
    mat-raised-button
    data-testid="addOneByOneButton"
  >
    Generate slides one by one (+1)
  </button>
  <button
    mat-button
    type="button"
    class="h-8 px-10 text-xs font-semibold bg-project-4500/60 text-project-300"
    (click)="createGallerySlides()"
    mat-raised-button
    data-testid="addSlidesButton"
  >
    Generate slides by image
  </button>
</div>
<div cdkDropList (cdkDropListDropped)="drop($event)">
  <app-slide
    *ngFor="let slide of slideArray.controls; let index = index"
    cdkDrag
    (cdkDragStarted)="dragStarted()"
    class="py-2"
    [index]="index"
    [slide]="slide.value"
    [changingSlideOrder$]="changingSlideOrder$"
    [isDisabled]="isDisabled"
    (slideOrderChanged)="slideOrderChanged($event)"
    (removeSlideClick)="removeSlideClick($event)"
    (slideChanged)="slideChanged($event)"
    (bookmarkChanged)="bookmarkChanged($event)"
  ></app-slide>
</div>
